module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/en-合作与发展banner.d73bb646.png";